
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class AccountingCompanyStatusModel extends Model<AccountingCompanyStatusModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'accountingCompanyStatus.property.companyId' },
		{ name: 'inDebtCollection', type: 'boolean', languageString: 'accountingCompanyStatus.property.inDebtCollection' },
		{ name: 'hasOverdueLedgers', type: 'boolean', languageString: 'accountingCompanyStatus.property.hasOverdueLedgers' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public inDebtCollection: boolean;
	public hasOverdueLedgers: boolean;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.inDebtCollection = false;
		this.hasOverdueLedgers = false;
		
	}
	getProperties(){
		return AccountingCompanyStatusModel.classProperties;
	}
}

